import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_USER_NOTIFICATION_SETTINGS = 'FETCH_USER_NOTIFICATION_SETTINGS';
export const FETCH_USER_NOTIFICATION_SETTINGS_SUCCESS = 'FETCH_USER_NOTIFICATION_SETTINGS_SUCCESS';
export const FETCH_USER_NOTIFICATION_SETTINGS_FAIL = 'FETCH_USER_NOTIFICATION_SETTINGS_FAIL';
export const UPDATE_USER_NOTIFICATION_SETTINGS = 'UPDATE_USER_NOTIFICATION_SETTINGS';
export const UPDATE_USER_NOTIFICATION_SETTINGS_SUCCESS = 'UPDATE_USER_NOTIFICATION_SETTINGS_SUCCESS';
export const UPDATE_USER_NOTIFICATION_SETTINGS_FAIL = 'UPDATE_USER_NOTIFICATION_SETTINGS_FAIL';

// Reducer
export default function userNotificationSettingsReducer(state = { data: [], loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_USER_NOTIFICATION_SETTINGS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_USER_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_USER_NOTIFICATION_SETTINGS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case UPDATE_USER_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        data: state.data.map(dataItem => (payload.data[dataItem.ID])),
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchUserNotificationSettings(payload) {
  return { type: FETCH_USER_NOTIFICATION_SETTINGS, payload };
}

export function fetchUserNotificationSettingsSuccess(payload) {
  return { type: FETCH_USER_NOTIFICATION_SETTINGS_SUCCESS, payload };
}

export function fetchUserNotificationSettingsFail(payload) {
  return { type: FETCH_USER_NOTIFICATION_SETTINGS_FAIL, payload };
}

export function updateUserNotificationSettings(payload) {
  return { type: UPDATE_USER_NOTIFICATION_SETTINGS, payload };
}

export function updateUserNotificationSettingsSuccess(payload) {
  return { type: UPDATE_USER_NOTIFICATION_SETTINGS_SUCCESS, payload };
}

export function updateUserNotificationSettingsFail(payload) {
  return { type: UPDATE_USER_NOTIFICATION_SETTINGS_FAIL, payload };
}

// Requests
export function requestFetchUserNotificationSettings() {
  return callApi('settings/user_notification_settings/');
}

export function requestUpdateUserNotificationSettings(payload) {
  return callApi('settings/user_notification_settings/', 'PATCH', payload);
}

// Sagas
function* fetchUserNotificationSettingsSaga(action) {
  const { triggerLoading } = action.payload;
  try {
    const res = yield call(requestFetchUserNotificationSettings, action.payload);
    yield put(fetchUserNotificationSettingsSuccess({
      data: res.data,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchUserNotificationSettingsFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* updateUserNotificationSettingsSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateUserNotificationSettings, values);
    yield put(updateUserNotificationSettingsSuccess({
      data: res.data,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Notification settings successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updateUserNotificationSettingsFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* userNotificationSettingsSaga() {
  yield takeEvery(FETCH_USER_NOTIFICATION_SETTINGS, fetchUserNotificationSettingsSaga);
  yield takeEvery(UPDATE_USER_NOTIFICATION_SETTINGS, updateUserNotificationSettingsSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/userNotificationSettings.js